import { ColumnOutputType } from 'app/component-library/table/column-output-type';
import * as moment from 'moment';
import { TableColumn } from '../../../../component-library/table/table-column';
import { TableConfig } from '../../../../component-library/table/table-config';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetParameter } from '../../../../viewmodels/dashboard/widget-parameter';
import { DisplayData } from '../bar/DisplayData';
import { ValueSource } from '../widget-parameters/value-source.enum';
import { ValueType } from '../widget-parameters/value-type.enum';
import { MitigationItemizedWidgetData } from './mitigation-itemized-widget-data';

export class MitigationsDueByMonthItemizedWidgetData extends MitigationItemizedWidgetData {
  public createTableConfig(): TableConfig {
    const tableConfig = super.initializeTableConfig();
    tableConfig.columns = this.createColumns();
    return tableConfig;
  }

  public setFilterParameter(widget: Widget, widgetParam: WidgetParameter, reset: boolean) {
    const paramIndex = widget.widgetItemizedDataParameters.findIndex(w => w.valueSource === ValueSource.None && w.valueType === ValueType.DateTime);

    if (paramIndex > -1) {
      if (!reset) {
        widget.widgetItemizedDataParameters[paramIndex] = widgetParam;
        return;
      }
      widget.widgetItemizedDataParameters.splice(paramIndex, 1);
      return;
    }
    if (!reset && widgetParam.valueSource === ValueSource.None && widgetParam.valueType === ValueType.DateTime) {
      widget.widgetItemizedDataParameters.push(widgetParam);
    }
  }

  protected createColumns(): TableColumn[] {
    return this.createMitigationColumns(false);
  }

  public createOverallTableHeaderColumn(): TableColumn {
    const headerCplumnTitle = 'Month';
    const headerColumn = new TableColumn(headerCplumnTitle, 'label');
    headerColumn.outputType = ColumnOutputType.Link;
    headerColumn.linkClickEvent = this.mitigationsDueByMonthDrillDown;
    return headerColumn;
  }

  protected mitigationsDueByMonthDrillDown = (data: DisplayData) => {
    const widgetParam = new WidgetParameter();
    widgetParam.widgetId = data.widgetId;
    widgetParam.valueSource = ValueSource.None;
    widgetParam.valueType = ValueType.DateTime;
    widgetParam.displayName = data.label;
    widgetParam.dateTimeValue = this.convertToDateTimeValue(data.label);

    this.viewDataTableService.setItemizedDataWidgetParam.next(widgetParam);
  };

  public convertToDateTimeValue(label: string): Date {
    const labelDateTimeValue = moment.utc(label, 'MMMM YYYY').toDate();
    return moment(labelDateTimeValue).isValid() ? labelDateTimeValue : null;
  }
}
